import { executeRequest, Request } from '@jfs/network'
import { InstrumentsParser } from '../network/parsers/InstrumentsParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return InstrumentsParser(respData)
}

const getMasterList = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.getMasterList}`,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { getMasterList }
